import { render } from "./CookiesTable.vue?vue&type=template&id=614adbfe&scoped=true"
import script from "./CookiesTable.vue?vue&type=script&lang=js"
export * from "./CookiesTable.vue?vue&type=script&lang=js"

import "./CookiesTable.vue?vue&type=style&index=0&id=614adbfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614adbfe"]])

export default __exports__